import { styled } from 'styled-components';

export const SnapDistributionChartSVG = styled.svg`
  width: 100%;
  padding: ${({ $padding }) => $padding || '0'};
  overflow: ${({ $withinTile }) => $withinTile && 'inherit !important'};

  .selectable-zone {
    &.selected {
      stroke: ${({ theme }) => theme.colours.canvas.primary.ink};
      stroke-dasharray: 5 3;
      stroke-width: 2;
      stroke-dashoffset: 0;
      /* Add a slight inset to prevent border overlap */
      stroke-linejoin: miter;
      stroke-linecap: butt;
    }

    /* Alternate dash pattern for adjacent zones to prevent visual clash */
    &.selected:nth-child(even) {
      stroke-dashoffset: 4;
    }

    &:hover {
      cursor: pointer;
      fill: ${({ theme }) => theme.colours.interface.main};
      fill-opacity: 0.5;
    }
  }
`;
